import { render, staticRenderFns } from "./application-form-review.vue?vue&type=template&id=3266b0a6&scoped=true&"
import script from "./application-form-review.vue?vue&type=script&lang=js&"
export * from "./application-form-review.vue?vue&type=script&lang=js&"
import style0 from "./application-form-review.vue?vue&type=style&index=0&id=3266b0a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3266b0a6",
  null
  
)

export default component.exports